import React, { Component } from "react";
import "../assets/css/bootstrap.css";
export default class NavbarComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }
  render() {
    return (
      <div className="w-100 px-3 py-2 bg-dark text-secondary text-end position-fixed" style={{left:0,bottom:0}}>
        @2025 Pantheon24 All rights reserved. version. {global.version}
      </div>
    );
  }
}
